import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

class SupportLoginCardLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="support-card-gradient mb-4 pointer-cursor">
        <div className="support-card-white-container pt-3 pb-3 pl-3">
          <Row className="align-items-center">
            <Col md={4} xs={4}>
              <div className="icon-container">
                <i className="icon-message" />
              </div>
            </Col>
            <Col md={8} xs={8} className="pl-0 pr-0">
              <div className="text-container">{this.props.mainTitle}</div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

SupportLoginCardLeft.propTypes = {
  mainTitle: PropTypes.string,
};

export default SupportLoginCardLeft;
